export const html_header_base_scripts = [
	// {
	// 	src: 'https://accounts.google.com/gsi/client',
	// 	defer: true,
	// 	async: true
	// },
	{
		vmid: 'gtm_helpers',
		id: 'gtmHelper',
		innerHTML: `
				updateGtmHelpers();
				function updateGtmHelpers() {

				if (!window.gtm_helpers){
					window.gtm_helpers = {
					"gclid": undefined,
					"ga_client_id_cookie": undefined,
					"client_id": undefined,
					"msclkid": undefined,
					"sznclid" : undefined,
				}
				}
				const urlParams = new URLSearchParams(window.location.search);

				const clickIdentifiers = {
					gclid: urlParams.get("gclid"),
					sznclid: urlParams.get("sznclid"),
					msclkid: urlParams.get("msclkid"),
					wbraid: urlParams.get("wbraid"),
					gbraid: urlParams.get("gbraid"),
					fbclid: urlParams.get("fbclid"),
				};

				for (identifier in clickIdentifiers) {
					let dlName = \`session_\${identifier}\`;
					let sessionName = \`\${identifier}_session\`;
					if (clickIdentifiers[identifier]) {
					if (window.dataLayer) {
						dataLayer.push({ dlName: clickIdentifiers[identifier] });
					}
					window.sessionStorage.setItem(sessionName, clickIdentifiers[identifier]);
					window.gtm_helpers[identifier] = clickIdentifiers[identifier];
					} else {
					let sessionValue = sessionStorage.getItem(sessionName);
					if (sessionValue) {
						clickIdentifiers[identifier] = sessionValue;
						if (window.dataLayer) {
						dataLayer.push({ dlName: clickIdentifiers[identifier] });
						}
						window.gtm_helpers[identifier] = clickIdentifiers[identifier];
					} else {
					}
					}
				}

				var cookie = {};
				document.cookie.split(";").forEach(function (el) {
					var splitCookie = el.split("=");
					var key = splitCookie[0].trim();
					var value = splitCookie[1];
					cookie[key] = value;
				});
				
				if(cookie["_ga"] !== undefined){
					window.gtm_helpers.client_id = cookie["_ga"].substring(6);
				}
				if(cookie["_ga"] !== undefined){
					window.gtm_helpers.ga_client_id_cookie = cookie["_ga"];
				}
			}`
	}
] as any;

export const html_header_prod_scripts = [].concat(html_header_base_scripts, [
	{
		vmid: 'gtm',
		id: 'gtmScript',
		innerHTML: `(function(w,d,s,l,i){
				w[l]=w[l]||[];
				for(const e of w[l]){
					if(e.hasOwnProperty('gtm.start')) return;
				}
				w[l].push({'gtm.start':	new Date().getTime(),event:'gtm.js'});
				var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),
					dl=l!='dataLayer'?'&l='+l:'';
				j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
				var n = d.querySelector('script[nonce]');
				n && j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'))
				f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${process.env.GOOGLE_GTM}');`
	},
	{
		vmid: 'convert_vars',
		id: 'convet_vars',
		innerHTML: `
				// fill in the values for the variables that you want to use
				var _conv_page_type = "";
				var _conv_category_id = "";
				var _conv_category_name = "";
				var _conv_product_sku = "";
				var _conv_product_name = "";
				var _conv_product_price = "";
				var _conv_customer_id = "";
				var _conv_custom_v1 = "";
				var _conv_custom_v2 = "";
				var _conv_custom_v3 = "";
				var _conv_custom_v4 = "";
			`
	},
	{
		vmid: 'convert_script',
		id: 'convertScript',
		src: '//cdn-4.convertexperiments.com/js/100411946-100412226.js'
	}
] as any);

// special scripts for DE, to handle cookie consent
export const html_header_prod_scripts_de = [].concat(html_header_base_scripts, [
	{
		once: true,
		src: 'https://cloud.ccm19.de/app.js?apiKey=d0944348dbbb4f81368760120093a1b4deaab6c3a55fb569&amp;domain=66b1ee18b850eb0e070ed1f2',
		referrerpolicy: 'origin'
	},
	{
		vmid: 'gtm',
		id: 'gtmScript',
		innerHTML: `(function(w,d,s,l,i){
				w[l]=w[l]||[];
				for(const e of w[l]){
					if(e.hasOwnProperty('gtm.start')) return;
				}
				w[l].push({'gtm.start':	new Date().getTime(),event:'gtm.js'});
				var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),
					dl=l!='dataLayer'?'&l='+l:'';
				j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
				var n = d.querySelector('script[nonce]');
				n && j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'))
				f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${process.env.GOOGLE_GTM}');`,
		type: 'text/x-ccm-loader',
		'data-ccm-loader-group': 'ccm-loader-gtm'
	},
	{
		vmid: 'convert_vars',
		id: 'convet_vars',
		type: 'text/x-ccm-loader',
		'data-ccm-loader-group': 'ccm-loader-convert',
		innerHTML: `
			// fill in the values for the variables that you want to use
			var _conv_page_type = "";
			var _conv_category_id = "";
			var _conv_category_name = "";
			var _conv_product_sku = "";
			var _conv_product_name = "";
			var _conv_product_price = "";
			var _conv_customer_id = "";
			var _conv_custom_v1 = "";
			var _conv_custom_v2 = "";
			var _conv_custom_v3 = "";
			var _conv_custom_v4 = "";
		`
	},
	{
		vmid: 'convert_script',
		id: 'convertScript',
		type: 'text/x-ccm-loader',
		'data-ccm-loader-group': 'ccm-loader-convert',
		src: '//cdn-4.convertexperiments.com/js/100411946-100412226.js'
	}
] as any);

// special scripts for CZ, to handle cookie consent
export const html_header_prod_scripts_cz = [].concat(html_header_base_scripts, [
	{
		once: true,
		src: 'https://cloud.ccm19.de/app.js?apiKey=d0944348dbbb4f81368760120093a1b4deaab6c3a55fb569&amp;domain=674ef180ea1611560600b0b2',
		referrerpolicy: 'origin'
	},
	{
		vmid: 'gtm',
		id: 'gtmScript',
		innerHTML: `(function(w,d,s,l,i){
				w[l]=w[l]||[];
				for(const e of w[l]){
					if(e.hasOwnProperty('gtm.start')) return;
				}
				w[l].push({'gtm.start':	new Date().getTime(),event:'gtm.js'});
				var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),
					dl=l!='dataLayer'?'&l='+l:'';
				j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
				var n = d.querySelector('script[nonce]');
				n && j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'))
				f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${process.env.GOOGLE_GTM}');`,
		type: 'text/x-ccm-loader',
		'data-ccm-loader-group': 'ccm-loader-gtm'
	},
	{
		vmid: 'convert_vars',
		id: 'convet_vars',
		type: 'text/x-ccm-loader',
		'data-ccm-loader-group': 'ccm-loader-convert',
		innerHTML: `
			// fill in the values for the variables that you want to use
			var _conv_page_type = "";
			var _conv_category_id = "";
			var _conv_category_name = "";
			var _conv_product_sku = "";
			var _conv_product_name = "";
			var _conv_product_price = "";
			var _conv_customer_id = "";
			var _conv_custom_v1 = "";
			var _conv_custom_v2 = "";
			var _conv_custom_v3 = "";
			var _conv_custom_v4 = "";
		`
	},
	{
		vmid: 'convert_script',
		id: 'convertScript',
		type: 'text/x-ccm-loader',
		'data-ccm-loader-group': 'ccm-loader-convert',
		src: '//cdn-4.convertexperiments.com/js/100411946-100412226.js'
	}
] as any);

export const chatling_script = {
	id: 'chatling-embed-script',
	'data-id': '2933327197',
	vmid: 'chatling_chat',
	src: 'https://chatling.ai/js/embed.js',
	async: true
};
